(() => {
function init(){const root=document.querySelector('#lightbot-shopify');if(!root || root.dataset.initialized)return;root.dataset.initialized='true';
const video = root.querySelector('#demo');
const play = root.querySelector('.video-play');
play.addEventListener('click', async () => { play.hidden = true; try { await video.play(); video.focus(); } catch { play.hidden = false; play.querySelector('b').textContent = 'TRY PLAYING AGAIN'; } });
video.addEventListener('play', () => { play.hidden = true; });
video.addEventListener('ended', () => { play.hidden = false; });

const heroFilm = root.querySelector('.hero-film');
const motionControl = root.querySelector('.motion-control');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
function syncMotionControl() { const paused = heroFilm.paused; motionControl.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video'); motionControl.firstElementChild.textContent = paused ? '▶' : 'Ⅱ'; }
async function playHeroFilm() { try { await heroFilm.play(); motionControl.hidden = false; syncMotionControl(); } catch { motionControl.hidden = false; syncMotionControl(); } }
if (!reducedMotion.matches) playHeroFilm();
motionControl.addEventListener('click', () => { if (heroFilm.paused) playHeroFilm(); else heroFilm.pause(); syncMotionControl(); });
heroFilm.addEventListener('play', syncMotionControl);
heroFilm.addEventListener('pause', syncMotionControl);
heroFilm.addEventListener('error', () => { motionControl.hidden = true; });
reducedMotion.addEventListener('change', event => { if (event.matches) { heroFilm.pause(); motionControl.hidden = true; } });

heroFilm.addEventListener('playing', () => heroFilm.classList.add('is-playing'));

const requestDialog = root.querySelector('#request');
let requestOpener;
root.querySelectorAll('[data-inquiry]').forEach(link => link.addEventListener('click', event => {
  event.preventDefault(); requestOpener = link;
  root.querySelector('#inquiry-type').value = decodeURIComponent(link.dataset.inquiry);
  requestDialog.showModal();
}));
requestDialog.querySelector('.request-close').addEventListener('click', () => requestDialog.close());
requestDialog.addEventListener('click', event => {
  const r = requestDialog.getBoundingClientRect();
  if(event.target === requestDialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) requestDialog.close();
});
requestDialog.addEventListener('close', () => { requestOpener?.focus(); });

const result = root.querySelector('[data-contact-result]');
if (result) {
  if (result.dataset.contactResult === 'success') {
    root.querySelector('#request-title').textContent = 'Request sent';
    root.querySelector('.request-intro').hidden = true;
  }
  requestDialog.showModal();
  result.focus();
}
requestDialog.querySelector('[data-confirm-close]')?.addEventListener('click', () => requestDialog.close());
}
init();document.addEventListener('shopify:section:load',init);
})();